module.exports = __webpack_public_path__ + "0a9f621e.png";